const faqs = [
  {
    id: 1,
    heading: 'How is custom woodwork different from prefabricated options?',
    content: 'Discover the benefits of choosing custom woodwork, including personalized design options, superior craftsmanship, and tailored solutions to match your unique style and space requirements.',
  },
  {
    id: 2,
    heading: 'What types of wood are commonly used in carpentry?',
    content: 'Learn about the characteristics and uses of popular wood species in carpentry, such as oak, maple, cherry, and walnut, to make informed decisions for your woodworking projects.',
  },
  {
    id: 3,
    heading: 'How do I maintain the quality and appearance of wooden furniture?',
    content: 'Discover effective maintenance tips for wooden furniture, including regular cleaning, polishing, and protection against moisture and pests, to prolong its lifespan and beauty.',
  },
  {
    id: 4,
    heading: 'Can I request customizations for my woodworking project?',
    content: 'Explore the possibilities of customizing your woodworking projects, such as choosing unique designs, dimensions, finishes, and detailing, to create truly one-of-a-kind pieces for your home or business.',
  },
  {
    id: 5,
    heading: 'How durable are wooden structures and furnishings?',
    content: 'Understand the durability and longevity of wooden structures and furnishings, including factors influencing lifespan, maintenance requirements, and the importance of quality craftsmanship for lasting results.',
  },
];

export default faqs;